<label class="visually-hidden" [attr.for]="labelId">{{ label }}</label>
<ng-container>
  <ng-select
    [labelForId]="labelId"
    (change)="eventSelected($event); select.blur()"
    [items]="eventList"
    bindLabel="title"
    [loading]="searchLoading"
    [searchable]="!simpleSelect"
    [(ngModel)]="internalSelectedEvent"
    [placeholder]="placeholder"
    #select>
  </ng-select>
  <ng-container
    *ngIf="internalSelectedEventList && internalSelectedEventList.length">
    <div>
      <ng-container *ngFor="let eachEvent of internalSelectedEventList">
        <span
          class="badge badge-item mt-2"
          (click)="removeEventFromList(eachEvent)"
          >{{ eachEvent.title }}<i class="bi bi-x mx-2"></i
        ></span>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
